import { render } from "./TariffMiniView.vue?vue&type=template&id=25bd86f4&scoped=true"
import script from "./TariffMiniView.vue?vue&type=script&lang=js"
export * from "./TariffMiniView.vue?vue&type=script&lang=js"

import "./TariffMiniView.vue?vue&type=style&index=0&id=25bd86f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bd86f4"]])

export default __exports__